import React from "react";
import { usePageData } from "../PageData";
import { SwiperCarousel } from "./SwiperCarousel";

export default function LandingSwiperCarousel({ onlyGroup = null }) {
  const data = usePageData();
  if (!data || !data.carouselBanners?.length) return null;

  const bannersByGroup = data.carouselBanners.reduce((acc, banner) => {
    const group = banner.carouselGroup ?? 0;
    if (!acc[group]) acc[group] = [];
    acc[group].push(banner);
    return acc;
  }, {});

  const groups = Object.entries(bannersByGroup).sort(
    ([a], [b]) => parseInt(a) - parseInt(b)
  );

  let bannersToShow = [];

  if (onlyGroup === null) {
    // Se null → prendi 0 e 1 insieme
    bannersToShow = [...(bannersByGroup[0] || []), ...(bannersByGroup[1] || [])];
  } else if (Array.isArray(onlyGroup)) {
    // Se è array → unisci tutti quelli inclusi
    onlyGroup.forEach(g => {
      bannersToShow.push(...(bannersByGroup[g] || []));
    });
  } else {
    // Se è singolo numero
    bannersToShow = bannersByGroup[onlyGroup] || [];
  }

  return <SwiperCarousel banners={bannersToShow} />;
}